import { useState, useEffect } from "react";

export default function useDarkSide() {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme || "system";
  });

  const getColorTheme = (themeMode) => {
    if (themeMode === "system") {
      return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    }
    return themeMode;
  };

  const colorTheme = getColorTheme(theme);

  useEffect(() => {
    const root = window.document.documentElement;
    const actualTheme = getColorTheme(theme);

    root.classList.remove("light", "dark");
    root.classList.add(actualTheme);

    localStorage.setItem("theme", theme);
    window.dispatchEvent(new Event("storage"));
  }, [theme]);

  useEffect(() => {
    // Only listen to system changes when theme is set to "system"
    if (theme !== "system") return;

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleSystemThemeChange = (e) => {
      // Only update if we're still in system mode
      if (theme === "system") {
        const root = window.document.documentElement;
        const newColorTheme = e.matches ? "dark" : "light";

        root.classList.remove("light", "dark");
        root.classList.add(newColorTheme);
      }
    };

    mediaQuery.addEventListener("change", handleSystemThemeChange);
    return () =>
      mediaQuery.removeEventListener("change", handleSystemThemeChange);
  }, [theme]);

  return [colorTheme, setTheme];
}
